module.exports = __webpack_public_path__ + "static/media/llanta-medicion-green.2da293a5.svg";